import React from 'react';
import PlanChooser from '../components/PlanChooser';
import './ChoosePlanPage.css';

export default function ChoosePlanPage() {
  return (
    <div className="choose-plan-page">
      <PlanChooser
        heading="Upgrade Required"
        body="This feature is not included in your current plan. Upgrade to unlock full access."
      />
    </div>
  );
}
